import WavesSvg from '@assets/images/svg/waves.svg';
import React from 'react';
import { View } from 'react-native';

export interface WavesIconProps {
    size?: number;
    color?: string;
}

export function WavesIcon({ size = 25, color = '#4D4D4D' }: WavesIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <WavesSvg width={size} height={size} color={color} />
        </View>
    );
}

export default WavesIcon;
